<template>
  <div class="datetime-picker-bound">
    <div class="d-flex align-items-center justify-content-between mb-half">
      <h3 class="typo-h15 typo-medium text-light-how" v-html="label"></h3>
      <Toggler :model-value="isOn" :disabled="toggleDisabled" @update:model-value="emitToggle" />
    </div>
    <DatePicker
      v-model="val"
      :class="{ disabled: pickerDisabled || !isOn }"
      is24hr
      :disabled="pickerDisabled || !isOn"
      locale="en"
      :model-config="modelConfig"
      mode="dateTime"
      :max-date="maxDate"
      :min-date="minDate"
      :from-date="fromDate"
      is-expanded
      trim-weeks
      @input="emitValue" />
  </div>
</template>

<script>
import { DatePicker } from 'v-calendar';
import 'v-calendar/dist/style.css';
export default {
  components: {
    DatePicker,
    // DatePickerV2,
  },
  props: {
    label: String,
    value: {
      type: [Date, String, Number],
      default: new Date(),
    },
    active: {
      type: Boolean,
      default: false,
    },
    toggleDisabled: {
      type: Boolean,
      default: false,
    },
    pickerDisabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: [Date, String, Number],
      default: null,
    },
  },
  emits: ['toggle', 'change-date-time'],
  data() {
    return {
      val: '',
      isOn: false,
    };
  },
  computed: {
    modelConfig() {
      return {
        type: 'string',
        mask: 'iso',
        is24hr: true,
        // timeAdjust: '12:00:00',
      };
    },
    minDate() {
      return this.min || new Date();
    },
    maxDate() {
      if (this.pickerDisabled || !this.isOn) {
        return new Date(Date.now() - 86400000);
      }
      return '';
    },
    fromDate() {
      if (this.value) {
        return new Date(this.value);
      }
      return new Date();
    },
  },
  watch: {
    value(newV, oldV) {
      if (newV === oldV) {
        return;
      }
      this.setValue(newV);
    },
    active(newV, oldV) {
      if (newV === oldV) {
        return;
      }
      this.setToggle(newV);
    },
  },
  mounted() {
    this.setValue(this.value);
    this.setToggle(this.active);
  },
  methods: {
    setValue(value) {
      if (this.val !== value) {
        this.val = value;
      }
    },
    setToggle(value) {
      if (value != this.isOn) {
        this.isOn = value;
      }
    },
    emitValue() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$emit('change-date-time', this.val);
        }, 100);
      });
    },
    emitToggle(newVal) {
      this.isOn = newVal;
      this.$emit('toggle', this.isOn);
    },
  },
};
</script>

<style lang="scss" scoped>
.vc-container.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.datetime-picker-bound {
  position: relative;
}
</style>
